import React from 'react';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeButton from '../../../Button/SubscribeButton';
export const TierButton = ({ deviation, className })=>{
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, null, /*#__PURE__*/ React.createElement(SubscribeButton, {
        className: className,
        tier: deviation,
        withPrice: true,
        showUnsubAsView: true
    }));
};
TierButton.displayName = 'TierButton';
export default TierButton;

//# sourceMappingURL=TierButton.js.map